export default defineNuxtRouteMiddleware((to) => {
	const { $configs } = useNuxtApp()
	const runtimeConfig = useRuntimeConfig()

	const showMaintenancePage = runtimeConfig.public.SHOW_MAINTENANCE_PAGE
	const shouldShowMaintenancePage = $configs.$isConfigEnabled(showMaintenancePage)

	if (shouldShowMaintenancePage) {
		if (to.path !== "/maintenance") {
			return navigateTo("/maintenance")
		}
	}

	// If not showing maintenance Page, allow access to all pages
	return
})
